export enum PetEnum {
  OK = "〇",
  NG = "✕"
}
